import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgWarning(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M51.5 37L39.127 14.5c-.103-.245-3.144-5.054-3.167-5.11-.023-.054-.799-1.256-1.447-1.679a4.45 4.45 0 00-2.213-.706 4.514 4.514 0 00-2.282.49c-.694.359-1.26.89-1.633 1.532L4.363 52.797A2.66 2.66 0 004 54.21c.014.492.167.971.444 1.393A3.03 3.03 0 005.58 56.62c.468.244.997.375 1.536.38h49.736a3.388 3.388 0 001.491-.34 3.055 3.055 0 001.136-.944 2.633 2.633 0 00.265-2.705C58.02 49.335 57.127 47.964 55.5 45",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      d: "M32 23v18",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("circle", {
      cx: 32,
      cy: 47,
      r: 2,
      fill: "#FF6652"
    }, void 0)]
  }), void 0);
}

export default SvgWarning;